export const TreatmentInfoAdvancedSectionName = 'general.treatmentInfoAdvanced';

export const TreatmentInfoAdvancedQuestionIds = {
    incisorLength: 5,
    incisalEdgeLengthening: 6,
    correctionOfRotations: 7,
    surfaceTexture: 8,
    shape: 9,
    contour: 10,
} as const;

export const TreatmentInfoAdvancedQuestionTitles: readonly string[] = [
    'messages.lateralIncisorLength',
    'messages.amountOfLengtheningIncisalEdge',
    'messages.correctionOfRotations',
    'messages.surfaceTexture',
    'messages.shapeAdvanced',
    'messages.contour',
];

export const TreatmentInfoAdvancedSectionNames: readonly string[] = [TreatmentInfoAdvancedSectionName];

export function isTreatmentInfoAdvancedQuestion(sectionName: string, questionName: string): boolean {
    return (
        TreatmentInfoAdvancedSectionNames.includes(sectionName) &&
        TreatmentInfoAdvancedQuestionTitles.includes(questionName)
    );
}
